export default "__VITE_ASSET__DaGNFntn__"